import { Link } from 'react-router-dom'

import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system'

import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { pallete } from '../../../theme'
import { avatarUrl } from '../../../utils'

const badgeStyle = {
  container: {
    width: '120px',
    paddingTop: '5px',
    textAlign: 'center'
  },
  avatar: {
    background: pallete.paperColor,
    color: pallete.headerColor,
    padding: '1px'
  },
  label: {
    color: pallete.textColor,
    fontWeight: 600
  }
}

const buttonStyle = {
  container: {
    borderRadius: 25,
    padding: 0,
    textAlign: 'left',
    display: 'block'
  },
  avatar_wrapper: {
    background: pallete.paperColor,
    color: pallete.headerColor,
    padding: '5px',
    borderRadius: '25px',
    display: 'inline-block'
  },
  avatar: {}
}

export const UserButton = (props) => {
  const { config } = useSelector((state) => state?.config)
  const { avatar_url, nick } = props
  const avatar = avatarUrl(config, avatar_url)

  return (
    <IconButton data-component="user-button" sx={buttonStyle.container}>
      <Box sx={buttonStyle.avatar_wrapper}>
        <Avatar sx={buttonStyle.avatar} alt={nick} src={avatar} />
      </Box>
    </IconButton>
  )
}

export const UnauthorizedBadge = () => {
  const { t } = useTranslation()
  return (
    <Box data-component="unauthorized-badge" sx={badgeStyle.container}>
      <IconButton sx={badgeStyle.avatar}>
        <Avatar sx={badgeStyle.avatar} />
      </IconButton>
      <Typography sx={badgeStyle.label}>{t('limitedAccess')}</Typography>
    </Box>
  )
}

const unauthorizedButtonStyle = {
  button: {
    background: pallete.paperColor,
    color: pallete.headerColor,
    padding: '0px',
    borderRadius: 25,
    '&:hover': {
      background: pallete.paperColor
    }
  },
  avatar: {
    background: pallete.paperColor,
    color: pallete.headerColor
  },
  label: {
    color: pallete.textColor,
    fontWeight: 600,
    paddingRight: '10px',
    fontSize: '0.75rem',
    '@media (min-width:400px)': {
      fontSize: '1rem'
    }
  }
}

export const UnauthorizedButton = (props) => {
  return (
    <IconButton
      component={Link}
      to="/login"
      data-component="unauthorized-button"
      sx={unauthorizedButtonStyle.button}
      disabled={props.disabled}
    >
      <Avatar sx={unauthorizedButtonStyle.avatar} />
    </IconButton>
  )
}
